<template>
  <div class="_rfp_mctb_slm_01_">
    <div class="_rfp_mctb_slm_05_ rfp-mctb-common-buynow-header">
      <div class="_rfp_mctb_slm_06_ rfp-mctb-slider-outer">
        <button
          class="_rfp_mctb_slm_07_ rfp-mctb-common-buynow rfp-mctb-product-list-card-buttom"
          @click="
            pageRedirectUrl(
              buyOffline.OfflineUrl,
              buyOffline.OpenInNewWindow,
              buyOffline.BuyOfflineTags,
              buyOffline.Name,
            )
          "
        >
          {{ offlineButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@refapp/eventbus-js';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';

export default {
  name: 'rfp-mctb-store-locator-mode',
  props: {
    buyOffline: {
      type: Object,
      required: false,
    },
    offlineButtonText: {
      type: String,
      required: false,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      extraParems: {},
    };
  },
  methods: {
    pageRedirectUrl(redirectURL, OpenInNewWindow, tagDatas, retailerName) {
      if (window.dataLayer !== undefined && tagDatas) {
        let tags = {};
        try {
          tags = JSON.parse(tagDatas);
        } catch (e) {
          console.log(
            'error/rfp-mctb-store-locator-mode#pageRedirectUrl: Standard (GA) tag parsing failed',
            e,
          );
        }

        eventBus.emit('rfpTaggingFoundation', {
          data: tags,
          values: {
            productName: this.productname,
            productId: this.productids,
            retailerName: retailerName,
          },
          service: ServiceType.GA,
        });
      }

      const target = OpenInNewWindow === true ? '_blank' : '_self';
      window.open(redirectURL, target);
    },
  },
};
</script>
